import { API, api } from "@/lib/api";

export const photoUrl = (id) => `${API}/reviews/photos/${id}`;

export const EMPTY_REVIEW = { name: "", location: "", rating: 5, title: "", text: "", trip: "", travel_month: "", phone: "", photos: [] };

export const monthLabel = (v) => {
  if (!v) return "";
  const d = new Date(`${v}-01T00:00:00`);
  return isNaN(d) ? v : d.toLocaleDateString("en-IN", { month: "short", year: "numeric" });
};

async function compressImage(file, max = 1600) {
  const bmp = await createImageBitmap(file).catch(() => null);
  if (!bmp) return file;
  const s = Math.min(1, max / Math.max(bmp.width, bmp.height));
  const c = document.createElement("canvas");
  c.width = Math.round(bmp.width * s);
  c.height = Math.round(bmp.height * s);
  c.getContext("2d").drawImage(bmp, 0, 0, c.width, c.height);
  return new Promise((res) => c.toBlob((b) => res(b || file), "image/jpeg", 0.85));
}

export async function uploadPhoto(file) {
  const fd = new FormData();
  fd.append("file", await compressImage(file), (file.name || "photo").replace(/\.\w+$/, "") + ".jpg");
  const { data } = await api.post("/reviews/photos", fd);
  return data.id;
}

export const reviewPayload = (f) => {
  const { photos, ...rest } = f;
  return { ...rest, rating: Number(f.rating), photo_ids: photos.map((p) => p.id) };
};
